import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useProductLifecycleTypes = () => {
    const { data, loading, error, refetch } = useApiQuery('/api/productlifecycletypes', 'get');
    return { data, loading, error, refetch };
};
